// https://govuk-elements.herokuapp.com/data/
import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { GREY_2 } from 'govuk-colours';
var CellHeader = styled('th')(function (_ref) {
  var _ref2;

  var alignRight = _ref.alignRight,
      bold = _ref.bold;
  return _ref2 = {
    border: 0,
    borderBottom: "1px solid " + GREY_2,
    fontFamily: NTA_LIGHT,
    fontWeight: bold ? 700 : 400,
    fontSize: FONT_SIZE.SIZE_16,
    lineHeight: LINE_HEIGHT.SIZE_16,
    padding: '0.63158em 1.05263em 0.47368em 0',
    textAlign: alignRight ? 'right' : 'left',
    textTransform: 'none',
    ':last-child': {
      paddingRight: 0
    }
  }, _ref2[MEDIA_QUERIES.LARGESCREEN] = {
    fontSize: FONT_SIZE.SIZE_19,
    lineHeight: LINE_HEIGHT.SIZE_19
  }, _ref2;
});
export default CellHeader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/table/es/atoms/CellHeader/index.js
// module id = 310
// module chunks = 0